// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import CreateTopic from './CreateTopic'
import PageEvents from '../page/PageEvents'
import NotAllowed from '../page/NotAllowed'
// import Editable from 'components/Editable/Editable'
// import ContentBox from 'components/ContentBox/ContentBox'
// import Recaptchas from 'components/Recaptchas/Recaptchas'
// import PageHeader from './PageHeader'
// import Content from './Content'

// Redux:
import { getForumData } from 'actions/forum'

const host = window.location.host

class Forum extends React.Component {
	componentDidMount() {
		if ( ! this.props.match ) {
			return
		}

		window.scrollTo( 0, 0 )

		const { params } = this.props.match
		// console.log( this.props.match, 'this.props.match' );

		this.props.getForumData( params.forum )
	}

	componentDidUpdate( prevProps, prevState ) {
		if ( ! this.props.match ) {
			return
		}

		window.scrollTo( 0, 0 )

		const { params, path } = this.props.match
		const prevParams = prevProps.match.params
		const prevPath = prevProps.match.path

		if ( prevParams.forum != params.forum ) {
			this.props.getForumData( params.forum )
		}
	}

	renderLoading() {
		return (
			<div className="primary-content-inner primary-content-is-loading">

			</div>
		)
	}

	renderContent() {
		const { forum, match } = this.props

		if ( ! forum ) {
			return null
		}

		document.title = forum.title.raw

		let markup = ''

		if ( forum.topics && Object.keys( forum.topics ).length ) {
			markup = Object.keys( forum.topics )
				.map( key => {
					let item = forum.topics[ key ],
						replyCount = item.replies_count

					return (
						<Link
							key={ item.id }
							to={ `${match.url}/${item.slug}` }
							data-slug={ item.slug }
							className="-topic card"
						>
							<div className="-inner">
								<header>
									<h3 dangerouslySetInnerHTML={ { __html: item.title.rendered } }></h3>

									<div className="-info">
										<i className="icon-chat-bubble-two" aria-hidden="true" />
										<span>{ replyCount }</span>
									</div>
								</header>

								<main>
									<div className="-text" dangerouslySetInnerHTML={ { __html: item.content.rendered } }></div>
								</main>
							</div>
						</Link>
					)
				})
		}

		return (
			<div className="primary-content-inner primary-content-is-ready">
				<PageEvents />

				<div>
					{ siteData.is_user_logged_in &&
						<CreateTopic />
					}

					<div className="forum-topics">
						{ markup }
					</div>
				</div>
			</div>
		)
	}

	render() {
		const { forum } = this.props

		if ( ! forum ) {
			return this.renderLoading()
		}

		if ( forum.status && 403 == forum.status ) {
			return <NotAllowed />
		}

		return (
			<div>
				{ this.props.isLoading ? this.renderLoading() : this.renderContent() }
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isLoading: state.forum.isLoading,
		forum: state.forum.selected
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		getForumData: ( slug ) => {
			dispatch( getForumData( slug ) )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( Forum )



// WEBPACK FOOTER //
// ./views/main/forum/Forum.jsx